import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

type Props = {
    message: string | null;

    // 'course' or 'playlist', lower case.
    itemLabel: string;
    onDismiss: () => void;
    onReload: () => void;
};

/*
    Someone else saved this content item while it was open, so the server refused the save.

    This is a dialog rather than a toast on purpose. The edits are still in the form, and a toast
    that disappears after a few seconds would read as a save that worked.
*/
export default function StaleVersionDialog({ message, itemLabel, onDismiss, onReload }: Props) {
    return (
        <Dialog open={!!message} onClose={onDismiss} maxWidth="sm">
            <DialogTitle>{`The ${itemLabel} was not saved`}</DialogTitle>

            <DialogContent>
                <DialogContentText>{message}</DialogContentText>
                <DialogContentText sx={{ marginTop: 2 }}>
                    Your changes are still on this page. Copy anything you need before you reload, because reloading
                    replaces them with the version that was saved.
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button onClick={onDismiss}>Keep editing</Button>
                <Button variant="contained" color="primary" onClick={onReload}>
                    {`Reload the ${itemLabel}`}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
